import { useEffect, useState } from "react";
import PanelistStudywiseTable from "../../components/PanelistStudywiseTable/PanelistStudywiseTable";
import ClaimListCard from "../../components/ClaimListCard/ClaimListCard";
import { getUnclaimedStudies } from "./UnclaimedPanelistStudies.api";
import { useAuth } from "context/auth-context";
import { useQuery } from "@tanstack/react-query";
import { Card } from "components/ui";

const UnclaimedPanelistStudies = ({ setLoading }: any) => {
  const [claimList, setClaimList] = useState([]);
  const { auth } = useAuth();

  const { data, isLoading, refetch, isFetching } = useQuery(
    ["unclaimedStudies"],
    () => getUnclaimedStudies(auth.panelistId),
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (isLoading || isFetching) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [isLoading, isFetching, data?.data]);
  return (
    <div className="grid items-start grid-cols-1 gap-4 lg:grid-cols-[minmax(0,1fr)_320px]">
      <Card
        title="Completed studies"
        subtitle="Add the studies you want to claim, then send the request from your claim list."
        flush
        className="min-w-0"
      >
        <PanelistStudywiseTable
          studiesData={data}
          setClaimList={setClaimList}
          claimList={claimList}
          isLoading={isLoading}
        />
      </Card>
      <div className="lg:sticky lg:top-[calc(var(--zs-topbar-h)+16px)]">
        <ClaimListCard claimList={claimList} refreshList={refetch} setClaimList={setClaimList} />
      </div>
    </div>
  );
};

export default UnclaimedPanelistStudies;
